<div class="mat-dialog-container">
  <h2 mat-dialog-title>{{title}}</h2>
  <mat-dialog-content [innerHtml]="sanitizeMessage(message)"></mat-dialog-content>
  <mat-dialog-actions class="justify-flex-end">
    <button mat-raised-button color="primary" id="confirm-accept-button" [mat-dialog-close]="ModalExit.COMPLETE">{{acceptText}}</button>
    <button mat-raised-button color="accent" id="confirm-cancel-button" *ngIf="showCancel" [mat-dialog-close]="ModalExit.CANCELED" >{{cancelText}}</button>
  </mat-dialog-actions>
</div>